const defaultColumns = [{
    name: 'Total Fee',
    key: 'totalFee',
    format: '$',
    withCents: true,
}, {
    name: 'Referral',
    key: 'referral',
    format: '$',
    withCents: true,
}, {
    name: 'Credits',
    key: 'credits',
    format: '$',
    withCents: true,
}, {
    name: 'Bank Bonus',
    key: 'bankBonus',
    format: '$',
    withCents: true,
}, {
    name: 'AthCap Gross',
    key: 'hscGross',
    format: '$',
    withCents: true,
}, {
    name: 'Cumulative',
    key: 'cumulative',
    format: '$',
    withCents: true,
}, {
    name: 'Agent Net',
    key: 'agentNet',
    format: '$',
    withCents: true,
}, {
    name: 'AthCap Net',
    key: 'hscNet',
    format: '$',
    withCents: true,
}];

export const totalColumns = [
    {
        name: '',
        key: 'title',
        class: 'PipelineTable_align_left',
    },
    ...defaultColumns,
    {
        name: 'Loan Amount',
        key: 'loanAmount',
        format: '$',
    }
];

export const columns = [
    {
        name: 'Date',
        key: 'date',
        format: 'date',
    }, {
        name: 'Property - City, State',
        key: 'property',
        hasLink: 'property',
    },
    ...defaultColumns,
    {
        name: 'Referred by',
        key: 'referredBy',
    }
];